import {
  FaGithub,
  FaLinkedin,
  FaTwitter,
  FaReddit,
  FaEnvelope,
} from 'react-icons/fa';

const socialLinks = [
  {
    id: 1,
    site: 'GitHub',
    url: 'https://github.com/amand33p',
    icon: <FaGithub />,
  },
  {
    id: 2,
    site: 'LinkedIn',
    url: 'https://www.linkedin.com/in/amand33p',
    icon: <FaLinkedin />,
  },
  {
    id: 3,
    site: 'Twitter',
    url: 'https://www.twitter.com/amand33p_s',
    icon: <FaTwitter />,
  },
  {
    id: 4,
    site: 'Reddit',
    url: 'https://www.reddit.com/u/aman_d33p',
    icon: <FaReddit />,
  },
];

export const emailLink = {
  id: 99,
  url: 'mailto:amandeep96x@gmail.com',
  icon: <FaEnvelope />,
};

export default socialLinks;
